import { Download } from 'lucide-react';
import React from 'react';
import { DropDownMenu } from '@/components/ui/DropDownMenu';
import { MassExportConfirmationDialogModal } from '@/pages/Vorgaenge/components/ExportDropDown/MassExportConfirmationDialogModal';

interface ExportDropDownActionsProps {
  isExporting: boolean;
  exportScopeLabel: string;
  onExportCurrentPage: () => Promise<void>;
  onExportAll: () => Promise<void>;
}

export const ExportDropDownActions: React.FC<ExportDropDownActionsProps> = ({
  isExporting,
  exportScopeLabel,
  onExportCurrentPage,
  onExportAll,
}) => {
  const [massExportConfirmationModalOpen, setMassExportConfirmationModalOpen] =
    React.useState(false);

  return (
    <>
      <DropDownMenu
        menuName="Export"
        isLoading={isExporting}
        items={[
          {
            label: 'Aktuelle Seite exportieren',

            icon: <Download className="h-4 w-4" />,
            onClick: onExportCurrentPage,
          },
          {
            label: 'Alles exportieren',
            icon: <Download className="h-4 w-4" />,
            onClick: () => setMassExportConfirmationModalOpen(true),
          },
        ]}
      />
      <MassExportConfirmationDialogModal
        open={massExportConfirmationModalOpen}
        scopeLabel={exportScopeLabel}
        onConfirm={() => {
          void onExportAll();
          setMassExportConfirmationModalOpen(false);
        }}
        onCancel={() => {
          setMassExportConfirmationModalOpen(false);
        }}
      />
    </>
  );
};
